// extracted by mini-css-extract-plugin
export default {"modalDialog":"nrINNy28","error":"IHEwWBxd","sticker":"wlPR2AOa","description":"bgrj6VK3"};